module.exports = __webpack_public_path__ + "img/simple_attention.905395e7.png";